import { FormLabel } from "@mui/material";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import React from "react";

export default function SwitchCmp({
  Label = "",
  checked,
  onChange,
  onlabel,
  offlabel,
  colSize,
}: {
  Label: string;
  checked: boolean;
  onChange: any;
  onlabel: string;
  offlabel: string;
  colSize: string;
}) {
  return (
    <div>
      <div
        className={colSize}
        style={{
          textAlign: "right",
          alignItems: "center",
          display: "flex",
          //   maxWidth: "3em",
          minWidth: "3em",
        }}
      >
        <FormLabel
          style={{
            fontFamily: "iranSans",
            color: "#757575",
            verticalAlign: "middle",
            fontSize: "15px",
          }}
        >
          {Label}
        </FormLabel>
      </div>
      <div
        style={{
          maxWidth: "6em",
          minWidth: "3em",
          direction: "initial",
        }}
      >
        <BootstrapSwitchButton
          style="rounded-pill mb-3"
          checked={checked}
          onlabel={onlabel}
          offlabel={offlabel}
          onChange={onChange}
          onstyle="primary"
        />
      </div>
    </div>
  );
}
